import React, { useState, useEffect, useCallback } from 'react';
import { Card, CardBody, CardHeader } from 'reactstrap';
import api from '../../../api';
import DataTable from './DataTable';
import RefreshTimer from './RefreshTimer';

const columns = [
    { key: 'EmployeeName', label: 'Employee Name' },
    { key: 'Direct', label: 'Direct' },
    { key: 'Indirect', label: 'Indirect' },
    { key: 'Description', label: 'Description' },
    { key: 'JobNum', label: 'Job #', cellStyle: { fontWeight: 700, fontFamily: '"Courier New", monospace' } },
    { key: 'PartNum', label: 'Part #' },
    { key: 'JobQty', label: 'Job Qty' },
    { key: 'StartTime', label: 'Start Time' },
];

const ProductionTab = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchData = useCallback(async () => {
        try {
            setLoading(true);
            setError(null);
            const res = await api.get('/display-board/production');
            setData(res.data?.employees || []);
        } catch (err) {
            setError(err.response?.data?.error || err.message || 'Failed to load Production data');
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => { fetchData(); }, [fetchData]);

    return (
        <Card className="border-0 shadow-sm">
            <CardHeader className="border-bottom d-flex justify-content-between align-items-center py-3">
                <h6 className="mb-0 fw-semibold">
                    <i className="ri-hammer-line me-2 text-warning"></i>
                    Production — Flex Department — Display Board
                </h6>
                <RefreshTimer onRefresh={fetchData} interval={60} />
            </CardHeader>
            <CardBody className="p-0">
                {error && (
                    <div className="alert alert-danger m-3 mb-0" role="alert">
                        <i className="ri-error-warning-line me-2"></i>{error}
                    </div>
                )}
                <DataTable
                        highlightKey="JobNum"  // Round DB-1 — green = active job
                    columns={columns}
                    rows={data}
                    loading={loading}
                    emptyMessage="No Production employees clocked in today"
                />
            </CardBody>
        </Card>
    );
};

export default ProductionTab;